var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSearchNew = function SvgIconSearchNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.0915993,15.8602992 L17.6584661,16.2475683 C17.2680603,16.6022178 16.8488155,16.9207643 16.4054738,17.1996048 C15.7898384,17.5586492 15.1355745,17.8403084 14.4563746,18.0386879 C10.7858679,19.0986562 6.88826765,17.4750157 4.92744512,14.0691796 C4.36340784,13.0810958 4.00010152,11.9826161 3.86008126,10.8419372 C3.39296208,7.37511215 4.99860836,3.96139099 7.91297009,2.22519976 C11.904796,-0.124890384 16.9641587,1.25341955 19.3445916,5.33948875 C21.2950118,8.72993148 20.778035,13.0707524 18.0915993,15.8602992 L18.0915993,15.8602992 Z",
    id: "Searchpath-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4940346,23.0603895 L19.5533889,16.2410644 C20.9231108,14.7263246 21.7717481,12.8039188 21.9725498,10.7609746 C22.1841674,8.71657198 21.7472083,6.65707886 20.7249322,4.88065365 C17.986743,0.27986136 12.1036704,-1.24246408 7.51844412,1.46329434 C5.30791804,2.73314999 3.69975342,4.85442169 3.06049363,7.34361532 C2.41301588,9.82692318 2.76884642,12.4688348 4.04945876,14.6863198 C6.21232173,18.2998686 10.4088775,20.119512 14.4868445,19.2120119 L18.4274902,26.0159435 C18.6195735,26.3518062 18.8983143,26.6284992 19.2338771,26.816406 C19.56827,27.0090582 19.9446517,27.1148364 20.3293462,27.1242762 C20.7151212,27.122445 21.0933753,27.0161406 21.4248152,26.816406 L22.7332922,26.062124 C23.2277262,25.7651659 23.5880324,25.2846397 23.7374722,24.7228886 C23.8802835,24.1581329 23.7925526,23.5589953 23.4940346,23.0603895 Z M5.23621691,13.9320378 C4.69290419,12.9854019 4.34120523,11.9388465 4.20160724,10.8533357 C4.04920644,9.77935877 4.11129055,8.68536332 4.38418542,7.63609202 C4.65897542,6.5897726 5.14030484,5.61057325 5.79916629,4.75750557 C6.45171681,3.90764961 7.26342944,3.1962533 8.18789743,2.66398815 C12.1141281,0.422065678 17.0903534,1.7369361 19.4316702,5.63493566 C21.2842221,8.86706975 20.7396688,12.9580159 18.1079784,15.5791434 L17.6819626,15.9639812 C17.3004095,16.3008833 16.8877078,16.5998682 16.4495599,16.8568048 C15.8453986,17.1949796 15.2079915,17.4684137 14.5477039,17.6726608 C10.9719686,18.6488087 7.18786247,17.1261645 5.25143176,13.9320378 L5.23621691,13.9320378 Z",
    id: "Searchpath-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.2---Ventas---Ventas-del-grupo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1317.000000, -144.000000)",
    id: "Info"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Search",
    transform: "translate(1037.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Searchmask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Searchpath-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#Searchmask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inside_color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Searchmask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Searchpath-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#744CC6",
    fillRule: "nonzero",
    xlinkHref: "#Searchpath-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SearchIcon",
    mask: "url(#Searchmask-4)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-body"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearchNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_search_new.5dcadcca.svg";
export { ForwardRef as ReactComponent };